module.exports = __webpack_public_path__ + "img/A5-3-plan.3a7752c8.png";